const randomResult = [
  ['1', '0', '6', '4', '9', '3', '2', '7', '3', '7', '8', '5', '8', '7', '8', '6', '6', '0'],
  ['5', '5', '1', '4', '3', '5', '1', '3', '5', '0', '2', '3', '5', '9', '0', '8', '0', '0'],
  ['7', '9', '4', '6', '9', '3', '7', '0', '5', '4', '3', '6', '8', '1', '2', '2', '0', '0'],
  ['2', '9', '6', '1', '3', '7', '4', '4', '3', '0', '9', '4', '4', '4', '8', '0', '6', '0'],
  ['2', '4', '4', '6', '7', '5', '4', '4', '0', '7', '4', '4', '6', '0', '5', '9', '0', '0'],
  ['7', '8', '4', '1', '5', '1', '3', '4', '8', '8', '8', '0', '0', '1', '4', '3', '0', '0'],
  ['3', '4', '7', '1', '3', '1', '8', '6', '9', '4', '7', '0', '4', '5', '9', '3', '0', '0'],
  ['8', '0', '9', '3', '1', '2', '8', '4', '0', '5', '5', '1', '7', '6', '6', '5', '0', '0'],
  ['6', '9', '3', '5', '5', '9', '1', '4', '1', '0', '1', '0', '0', '8', '8', '3', '0', '0'],
  ['6', '3', '0', '8', '8', '0', '9', '4', '8', '8', '5', '7', '3', '6', '5', '2', '0', '0'],
  ['7', '9', '4', '1', '9', '6', '8', '8', '6', '3', '2', '6', '1', '8', '9', '8', '0', '0'],
  ['2', '4', '0', '5', '5', '8', '7', '4', '9', '1', '6', '9', '2', '4', '4', '8', '0', '0'],
  ['2', '3', '4', '8', '2', '3', '4', '3', '9', '6', '6', '2', '1', '5', '7', '7', '6'],
  ['5', '1', '3', '3', '8', '4', '5', '2', '0', '2', '6', '1', '1', '1', '4', '1', '0'],
  ['6', '0', '9', '9', '8', '8', '1', '1', '1', '7', '5', '8', '7', '7', '9', '3', '0', '0'],
  ['4', '9', '6', '6', '9', '6', '2', '5', '6', '0', '4', '1', '6', '9', '2', '1', '6', '0'],
  ['5', '0', '3', '0', '5', '0', '5', '3', '3', '7', '5', '3', '8', '7', '7', '5', '7', '0'],
  ['1', '1', '6', '5', '5', '0', '1', '1', '9', '6', '4', '2', '9', '5', '3', '6', '3', '0'],
  ['7', '6', '7', '9', '2', '9', '7', '0', '4', '0', '5', '7', '6', '5', '1', '6', '0', '0'],
  ['3', '4', '2', '3', '5', '4', '6', '5', '6', '5', '6', '6', '1', '4', '3', '9', '4', '0'],
  ['8', '0', '0', '5', '7', '3', '6', '7', '6', '4', '7', '2', '6', '6', '0', '1', '0', '0'],
  ['2', '6', '2', '5', '1', '1', '7', '5', '2', '1', '9', '0', '2', '1', '3', '1', '2', '0'],
  ['1', '7', '0', '2', '3', '8', '5', '8', '5', '3', '4', '0', '8', '4', '2', '0', '4'],
  ['4', '4', '2', '8', '3', '8', '8', '8', '2', '2', '8', '0', '8', '7', '8', '8', '0', '0'],
  ['7', '2', '7', '3', '1', '7', '6', '2', '9', '4', '6', '4', '7', '5', '9', '8', '0'],
  ['6', '3', '8', '6', '0', '5', '2', '2', '8', '3', '3', '7', '6', '9', '4', '3', '0', '0'],
  ['7', '7', '8', '1', '5', '9', '7', '4', '0', '6', '4', '2', '8', '2', '9', '8', '0', '0'],
  ['5', '9', '6', '4', '5', '5', '7', '3', '1', '1', '7', '1', '5', '9', '8', '6', '0', '0'],
  ['9', '1', '1', '9', '4', '8', '7', '9', '1', '2', '1', '8', '2', '6', '7', '5', '0'],
  ['3', '6', '1', '6', '2', '1', '6', '3', '6', '2', '4', '4', '1', '6', '5', '5', '7', '0'],
  ['4', '1', '4', '1', '4', '9', '1', '1', '3', '2', '8', '8', '7', '8', '5', '4', '0', '0'],
  ['5', '8', '1', '0', '4', '4', '7', '8', '0', '9', '6', '3', '7', '9', '3', '4', '0', '0']
]

function getResult (random) {
  switch (random) {
    case '766825710682844200':
      return 'A'

    case '725611211647484900':
      return 'B'

    case '477315480011637700':
      return 'C'

    case '125238983919727100':
      return 'D'

    case '623765044849821400':
      return 'E'

    case '373000498249866240':
      return 'F'

    case '416617567514433340':
      return 'G'

    case '682971065305736800':
      return 'H'

    case '58108038263742730':
      return 'I'

    case '825093665607336000':
      return 'J'

    case '128943858261871520':
      return 'K'

    case '366715392730048200':
      return 'L'

    case '34477741730341810':
      return 'M'

    case '797101674757003500':
      return 'N'

    case '717729054543889300':
      return 'O'

    case '834246409782502700':
      return 'P'

    case '278011715580342270':
      return 'Q'

    case '715720335247600600':
      return 'R'

    case '657082978569872000':
      return 'S'

    case '146783024279485150':
      return 'T'

    case '607858565871782800':
      return 'U'

    case '736163619278430200':
      return 'V'

    case '674894215817320000':
      return 'W'

    case '768646624909431400':
      return 'X'

    case '20467608226313604':
      return 'Y'

    case '504421525381163840':
      return 'Z'

    case '240558749169244800':
    case '72731762946475980':
    case '638605228337694300':
      return 'a'

    case '503050533753877570':
    case '262511752190213120':
      return 'b'

    case '702269491377184500':
      return 'c'

    case '504186740417006140':
      return 'd'

    case '794196886326189800':
      return 'e'

    case '693559141010088300':
    case '767929704057651600':
    case '778159740642829800':
    case '414149113288785400':
      return 'f'

    case '189180800374907360':
      return 'g'

    case '403437797329611140':
      return 'h'

    case '546221010383887550':
      return 'i'

    case '682488031345928200':
      return 'j'

    case '413699406557442700':
      return 'k'

    case '262463426066649380':
      return 'l'

    case '462915954909375800':
      return 'm'

    case '193317206143703040':
      return 'n'

    case '748468836098408400':
      return 'o'

    case '205769410044598900':
      return 'p'

    case '74458287072520690':
      return 'q'

    case '781343959366820200':
      return 'r'

    case '720386843364309800':
      return 's'

    case '246921375319157020':
      return 't'

    case '757136378713843300':
      return 'u'

    case '656615846582224800':
      return 'v'

    case '556428207677717700':
      return 'w'

    case '11021497683362288':
      return 'x'

    case '571020581870033150':
      return 'y'

    case '358975053144357570':
      return 'z'

    case '347131869470459300':
    case '630880948857365200':
    case '116550119642953630':
      return '0'

    case '609988111758779300':
      return '1'

    case '244675440744605900':
    case '784151348880014300':
    case '17023858534084204':
    case '581044780963793400':
      return '2'

    case '106493273785878660':
    case '800573676472660100':
      return '3'

    case '23482343966215776':
    case '496696256041692160':
      return '4'

    case '809312840551766500':
    case '51338452026111410':
      return '5'

    case '442838882280878800':
      return '6'

    case '551435135023590800':
    case '596455731171598600':
    case '91194879121826750':
      return '7'

    case '342354656566143940':
    case '361621636244165570':
      return '8'

    case '794693705436812200':
    case '296137443094448060':
      return '9'
  }
}

function main () {
  let result = ''

  for (let i = 0, randomJoin; i < randomResult.length; i++) {
    randomJoin = randomResult[i].join('')

    result += getResult(randomJoin)
  }

  return result
}

export default main
